import NAME from "./constants";

export const RESET_STATE = NAME + "/RESET_STATE";

export const GET = NAME + "/GET";
export const GET_REJECTED = NAME + "/GET_REJECTED";
export const GET_FULFILLED = NAME + "/GET_FULFILLED";

export const CREATE = NAME + "/CREATE";
export const CREATE_REJECTED = NAME + "/CREATE_REJECTED";
export const CREATE_FULFILLED = NAME + "/CREATE_FULFILLED";

export const UPDATE = NAME + "/UPDATE";
export const UPDATE_REJECTED = NAME + "/UPDATE_REJECTED";
export const UPDATE_FULFILLED = NAME + "/UPDATE_FULFILLED";

export const CHANGE_PLAN = NAME + "/CHANGE_PLAN";
export const CHANGE_PLAN_REJECTED = NAME + "/CHANGE_PLAN_REJECTED";
export const CHANGE_PLAN_FULFILLED = NAME + "/CHANGE_PLAN_FULFILLED";

export const DELETE = NAME + "/DELETE";
export const DELETE_REJECTED = NAME + "/DELETE_REJECTED";
export const DELETE_FULFILLED = NAME + "/DELETE_FULFILLED";